import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Caret Double Left Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M250.098 233.962c6.21 6.21 3.37 16.815-5.114 19.088a11.41 11.41 0 0 1-11.02-2.953l-114.03-114.03c-4.46-4.453-4.46-11.68 0-16.134l114.03-114.03c6.21-6.21 16.814-3.369 19.087 5.115a11.41 11.41 0 0 1-2.953 11.02L144.122 128ZM30.093 128 136.069 22.038c6.21-6.21 3.369-16.815-5.115-19.088a11.41 11.41 0 0 0-11.02 2.953L5.904 119.933c-4.459 4.454-4.459 11.68 0 16.135l114.03 114.03c6.21 6.21 16.815 3.368 19.088-5.116a11.41 11.41 0 0 0-2.953-11.02Z" }, null, -1)
  ]))]))
}
export default { render: render }